import { render } from "./ChangePassword.vue.js?vue&type=template&id=1ed5fd7c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangePassword.vue?vue&type=template&id=1ed5fd7c"
import script from "./ChangePassword.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-settings-page/ChangePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ed5fd7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ed5fd7c', __exports__)) {
    api.reload('1ed5fd7c', __exports__)
  }
  
  module.hot.accept("./ChangePassword.vue.js?vue&type=template&id=1ed5fd7c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangePassword.vue?vue&type=template&id=1ed5fd7c", () => {
    api.rerender('1ed5fd7c', render)
  })

}


export default __exports__